
const initialState = {
    status:"",
    percentage:""
};

const statusChanges = (state = initialState, action) => {
switch (action.type) {
  case "STATUS_CHANGES":
    return {
      ...state,
      ...action.payload
    };
  default:
    return state;
}
};

export default statusChanges;
